"use client";
import EventMWC from "@/components/Events/EventMWC";

export default function EventMWCPage() {
  return <EventMWC />;
}
